<template>
  <div class="row">
    <div class="col-12 col-lg-7 c g">
        <div class="card">
            <div class="card-header">
                <h5>
                    <i class="fa fa-calendar"></i>
                    الاجازات / العطلات
                    &nbsp;
                    <button class="btn btn-primary btn-sm" v-b-modal.add style="border-radius: 50%; width: 30px; height: 30px; padding:0px">
                        <i class="fa fa-plus"></i>
                    </button>
                </h5>
            </div>
            <div class="card-footer">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered">
                        <thead>
                            <th>
                                العنوان
                            </th>
                            <th>
                                التاريخ
                            </th>
                            <th>
                                خيارات
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="a in list" :key="a._id">
                                <td>
                                    {{ a.title }}
                                </td>
                                <td>
                                    {{ a.date }}
                                </td>
                                <td>
                                    <button class="btn btn-sm btn-outline-danger" @click="deleteDay(a.date)" style="border-radius: 0px;padding: 5px">
                                        <i class="fa fa-trash"></i> حذف
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <b-modal id="add" title="اضافة اجازة" hide-footer>
        <div class="form-group">
          <label for="">اليوم من</label>
          <input type="date"
            class="form-control" v-model="date">
        </div>
        <div class="form-group">
          <label for="">اليوم الى</label>
          <input type="date"
            class="form-control" v-model="to">
        </div>
        <div class="form-group">
          <label for="">عنوان الاجازة</label>
          <input type="text"
            class="form-control" v-model="title" placeholder="اكتب هنا...">
          <small id="helpId" class="form-text text-muted">مثل: تعليق دراسة٫ عيد الاضحى الخ...</small>
        </div>
        <div class="col-12 text-center g text-center">
            <button class="btn btn-primary" @click="addnow()">
                اضافة الاجازة
            </button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import {  VBModal, BModal, BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    BModal
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            list: [],
            date: new Date().toISOString().split("T")[0],
            title: "",
            to: new Date().toISOString().split("T")[0],
        }
    },
    created(){
        this.getList()
    },
    methods: {
        addnow(){
            var g = this;
            $.post(api + '/admin/settings/freedays/add', {
                jwt: localStorage.getItem("jwt"),
                from: this.date,
                to: this.to,
                title: this.title
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.getList()
                    $("#add___BV_modal_header_ > button").click()
                }
            }).fail(function(){
            
            })
        },
        getList(){
            var g = this;
            $.post(api + '/admin/settings/freedays/list', {
                jwt: localStorage.getItem("jwt")
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.list = r.response
                }
            }).fail(function(){
            
            })
        },
        deleteDay(id){
            if(confirm("متأكد من حذف هذا اليوم من الاجازات؟\nقد يؤثر هذا الاجراء على التقارير السابقة.")){
                var g = this;
                $.post(api + '/admin/settings/freedays/delete', {
                    jwt: localStorage.getItem("jwt"),
                    date: id
                }).then(function(r){
                    g.loading = false
                    if(r.status != 100){
                        alert(r.response)
                    }else{
                        g.getList()
                    }
                }).fail(function(){
                
                })
            }
        }
    }
}
</script>

<style>

</style>